import React, { useEffect, useState } from 'react';
import {
  Demanda,
  ExportarDemandaAndamento,
  getAllDemandantes,
  getAllRequisitantes,
  getDemandasDemandante,
  getDemandasPreSuprimentosAndamento,
} from '@app/api/demanda';
import { Button, Loading, OptionProps, useRouter, Widget } from '@digital/ui';
import GridDemandas from './GridDemandas';
import { Tooltip } from 'antd';
import { FormSelectFilter } from '@app/components/FormSelectFilter';



const DemandasAndamento = (props: any) => {
  const { history } = useRouter();
  const [dados, setDados] = useState<Demanda[]>([]);
  const [update, setUpdate] = useState(false);
  const { usuarioPreSuprimentosOuAdmContratos } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItens, setTotalItens] = useState(0);

  const [listDemandantes, setDemandantes] = useState<OptionProps[]>([]);
  useEffect(() => {
    getAllDemandantes().then(data => {
      if (data) {
        setDemandantes(data);
      }
    });
    
  }, []);

  const [requisitantes, setRequisitantes] = useState<OptionProps[]>([]);
  useEffect(() => {
    getAllRequisitantes().then(data => {
      if (data) {
        setRequisitantes(data);
      }
    });
    
  }, []);
  
   const listarDemandas = (
     pagination: { current?: number; pageSize?: number } = { },
     filters?: Record<string, (string | number)[] | null>,
     sorter?: any,
   ) => {
     const { current = 1, pageSize = 10 } = pagination;
      const filtroBase = {
       PreSuprimentos : usuarioPreSuprimentosOuAdmContratos,
       ConcluidoCancelado : false,
     };
     getDemandasDemandante(filtroBase, current, pageSize, filters, sorter).then(data => {
       if (data) {
        setDados(data.items);
        setPageSize(data.pageSize);
        setTotalPage(data.totalPages);
        setTotalItens(data.totalItems);
       }
     });
   };

  useEffect(() => {
    listarDemandas();
  }, [update, usuarioPreSuprimentosOuAdmContratos]);


  const [exportando, setExportando] = useState(false);

  const handleExportar = async () => {
    try {
      setExportando(true);
      await ExportarDemandaAndamento();
    } finally {
      setExportando(false);
    }
  };

  return (
    <Widget
      title="Em Andamento"
      actions={[
        <>
          <Button
            id="mrn-btn-criar-nova-demanda"
            title="criar nova demanda"
            type="primary"
            onClick={() => {
              history.push('/demanda/questionario/new');
            }}
          />
          <Tooltip title="Exportar demandas">
            <Button
              id="mrn-btn-exportar-demanda"
              type="link"
              icon="files-xls"
              onClick={handleExportar}
              style={{ marginRight: '8px' }}
              loading={exportando}
            />
          </Tooltip>
        </>,
      ]}>
      <GridDemandas dados={dados} 
      
         ///listarDemandas={listarDemandas}
                    //onUpdate={onUpdate}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalPage={totalPage}
                    totalItens={totalItens}
                    fetchData={listarDemandas}
                    demandantes={listDemandantes}
                    requisitantes={requisitantes}
                    />
    </Widget>
  );
};
export default DemandasAndamento;
